import { useNavigate, useParams } from 'react-router-dom';
import { 
  Modal, 
  ModalDialog, 
  ModalClose, 
  Typography, 
  Stack, 
  Button, 
  Alert,
  Box
} from '@mui/joy';
import { 
  useCreateRecipeFromTextMutation
} from '../api';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider } from 'react-hook-form';
import { FormTextarea } from '@/components/forms/FormTextarea';
import { fromTextSchema, newFromText } from '../schema';

export function AddRecipeFromTextPage() {
  const { householdId } = useParams();
  const navigate = useNavigate();
  const [createFromText, { isLoading, error }] = useCreateRecipeFromTextMutation();

  const form = useForm({
    defaultValues: newFromText(),
    resolver: yupResolver(fromTextSchema)
  });

  const handleClose = () => {
    form.reset();
    navigate(`/h/${householdId}/recipes`);
  };

  async function onSubmit(data) {
    try {
      const result = await createFromText({ householdId, text: data.text.trim() }).unwrap();
      form.reset();
      navigate(`/h/${householdId}/recipes/${result.data.id}`);
    } catch (err) {
      console.error('Failed to import recipe from text:', err);
    }
  }

  return (
    <Modal open={true} onClose={handleClose} disableRestoreFocus>
      <ModalDialog sx={{ maxWidth: '600px', width: '90%', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
        <ModalClose />
        <Typography level="h4" sx={{ mb: 1 }}>
          Add Recipe from Text
        </Typography>
        <FormProvider {...form}>
          <Box component="form" onSubmit={form.handleSubmit(onSubmit)} sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, gap: 3 }}>
            {error && (
              <Alert color="danger">
                {error.data?.error || error.message || 'Failed to add recipe'}
              </Alert>
            )}            
            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
              <Typography level="body-sm" sx={{ mb: 1 }}>
                Paste a recipe text to automatically extract recipe information
              </Typography>                
              <FormTextarea                  
                textareaProps={{ disabled: isLoading, autoFocus: true }}
                name="text"
                placeholder="Paste recipe text here..."
                minRows={6}
                sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}
                sxTextarea={{ flex: 1 }}
              />  
            </Box>              
            <Stack direction="row" spacing={1} justifyContent="flex-end">
              <Button variant="outlined" color="neutral" onClick={handleClose}>Cancel</Button>
              <Button type="submit" loading={isLoading} sx={{ px: 2.5 }}>Add Recipe</Button>
            </Stack>
          </Box>
        </FormProvider>
      </ModalDialog>
    </Modal>
  );
}